import React, {useContext, useState} from 'react'
import UploadFile from 'components/UploadFile';
import {makeStyles} from '@material-ui/core/styles';
import TitledComponent from 'components/TitledComponent';
import {Typography} from '@material-ui/core';
import CreateNewFolderIcon from '@material-ui/icons/CreateNewFolder';
import CreateFolderPopup from 'components/complex/documentsTables/repo/CreateFolderPopup';
import Tr from 'translations/Translations';
import SelectFolderPopup from 'components/complex/documentsTables/repo/SelectFolderPopup';
import RepoFolder from "./RepoFolder";
import RepoService from "services/RepoService";
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import SelectSiwzDocumentType from "../swz/SelectSiwzDocumentType";
import SiwzService from "../../../../services/SiwzService";
import DemandValidationContext from "../../../../context/DemandValidationContext";

const useStyles = makeStyles(theme => ({
    title: {
        fontWeight: "bold"
    },
    margin: {
        '&>*:first-child, &>*:nth-child(2)': {
            marginLeft: theme.spacing(2),
            marginBottom: theme.spacing()
        },
        '&>*:nth-child(3)': {
            margin: `0 ${theme.spacing(4)}px`
        }
    },
    buttonRow: {
        marginBottom: theme.spacing(1),
        marginTop: theme.spacing(1)
    }
}));

function SelectRepoDocument(
    {
        demandId,
        disabled,
        isPublished,
        folderList
    }) {

    const classes = useStyles();
    const currentDemandValidation = useContext(DemandValidationContext);
    const [portFilesWorking, setPostFilesWorking] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState(null);
    const [configuredFiles, setConfiguredFiles] = useState(null);
    const [moveToSiwzFolderAndFile, setMoveToSiwzFolderAndFile] = useState(null);

    const [openFolderPopup, setOpenFolderPopup] = useState(false);

    const handleSendFiles = (uploadedFiles, config) => {
        setConfiguredFiles(null);
        if(uploadedFiles.length) {
            setPostFilesWorking(true);
            RepoService.addFiles(demandId, config, uploadedFiles).finally(() => setPostFilesWorking(false));
        }
    };

    const handleSubmitSelectFolder = (values) => {
        setConfiguredFiles({files: selectedFiles, config: values})
        setSelectedFiles(null);
    };

    const getButtons = () => {
        if (!disabled) {
            const buttons = [];
            buttons.push(createButton(Tr("create_folder"), () => setOpenFolderPopup(true), undefined, undefined,
                undefined, undefined, CreateNewFolderIcon));

            if (buttons.length)
                return <MultiButton className={classes.buttonRow} buttons={buttons} justify="flex-start"/>
        }
    }

    const onMoveToSiwz = (folder, files) => {
        setMoveToSiwzFolderAndFile({folder: folder, files: files});
    }

    const doMoveToSiwz = (values, items) => {
        const folder = moveToSiwzFolderAndFile.folder;
        setMoveToSiwzFolderAndFile(null);
        if (items.length) {
            const tab = items.map((x, i) => ({
                ...x,
                type: values[`item${i}`],
                parent: values[`parent${i}`],
                autopublish: values[`autopublish${i}`],
            }));
            setPostFilesWorking(true)
            SiwzService.moveFromRepo(demandId, tab, currentDemandValidation).finally(() => {
                RepoService.refreshFolder(demandId, folder.identity).finally(() => setPostFilesWorking(false));
            });
        }
    }

    return (
        <>
            <TitledComponent title={Tr('internal_doc')}>

                {!disabled && <>

                    {getButtons()}

                    {!!folderList && folderList.length < 2 ?
                        <Typography color="error">{Tr('add_folder_before_file')}</Typography>
                        : <UploadFile
                            onOpenConfigureFiles={(files) => setSelectedFiles(files)}
                            configuredFiles={configuredFiles}
                            onUploadPopupClosed={handleSendFiles}
                            working={portFilesWorking}
                        />
                    }
                </>
                }

                {
                    folderList.map(x => (
                        <RepoFolder
                            key={x.identity}
                            demandId={demandId}
                            folder={x}
                            isPublished={isPublished}
                            disabled={disabled}
                            onMoveToSiwz={onMoveToSiwz}
                        />
                    ))
                }

            </TitledComponent>

            <CreateFolderPopup
                demandId={demandId}
                open={openFolderPopup}
                onClose={() => setOpenFolderPopup(false)}
            />

            {!!selectedFiles && <SelectFolderPopup
                onCancel={() => setSelectedFiles(null)}
                onSubmit={handleSubmitSelectFolder}
                folderList={folderList}
            />}

            {!!moveToSiwzFolderAndFile && <SelectSiwzDocumentType
                items={moveToSiwzFolderAndFile.files}
                onCancel={() => setMoveToSiwzFolderAndFile(null)}
                onSubmit={doMoveToSiwz}
                pickAutopublish={isPublished}
                pickParent={isPublished}
            />}

        </>
    )
}

export default SelectRepoDocument;